module.exports = __webpack_public_path__ + "img/cxTrends-mini-2.05dc9137.png";